<template>
  <div class="wrapper">
    <FORM ref="childForm" @formclick="formClick" :formData="formData"></FORM>
    <table-page ref="childTable" @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE ref="subscribeUpdate" @submit="subscribeSubmit" :updateData="subscribeData"></UPDATE>
    <UPDATE ref="subscribeSettingUpdate" :updateData="subscribeSettingData"></UPDATE>
  </div>
</template>

<script>
import tablePage from '@/components/page/table.vue'
import FORM from '@/components/page/form.vue'
import DateUtil from '@/utils/IM/tradeDataUtil.js'
import Qs from 'qs'
import Url from '@/views/merchandiser/util/url'
import UPDATE from '@/components/page/update'

let daysArr = { 1: '7天', 2: '30天', 3: '90天' }
let statusArr = { 1: '啟用', 2: '禁用' }

export default {
  name: 'list',
  components: {
    tablePage,
    FORM,
    UPDATE
  },
  mounted() {

  },
  methods: {
    subscribeSubmit(data) {
      this.dataChange(Url.signal.subscribe, data, res => {
        if (res.code == 0) {
          this.$message.success('操作成功')
          this.$refs.subscribeUpdate.close()
          this.$refs.childTable.defaultQueryData(this.queryData)
        } else {
          this.$message.error(res.message)
        }
      })
    },
    bthClick(clickName, row) {
      if (clickName == 'subscribe') {//
        this.subscribe(row)
      } else if (clickName == 'unsubscribe') {//
        this.unsubscribe(row)
      } else if (clickName == 'subscribeSetting') {//
        this.subscribeSetting(row)
      }
    },
    subscribeSetting(row) {
      this.dataChange(Url.signal.subscribeSetting, {
        'signalKey': row.signalKey,
        'customerNumber': row.subscribeCustomerNumber,
        'companyId': row.subscribeCompanyId
      }, res => {
        if (res.code == 0) {
          this.$refs.subscribeSettingUpdate.open(res.result)
        } else {
          this.$message.error(res.message)
        }
      })
    },
    unsubscribe(row) {
      this.dataChange(Url.signal.unsubscribe, {
        'signalKey': row.signalKey,
        'customerNumber': row.subscribeCustomerNumber,
        'companyId': row.subscribeCompanyId
      }, res => {
        if (res.code == 0) {
          this.$message.success('操作成功')
          this.$refs.childTable.defaultQueryData(this.queryData)
        } else {
          this.$message.error(res.message)
        }
      })
    },
    subscribe(row) {
      this.$refs.subscribeUpdate.open(row)
    },
    /*查询表单按钮点击事件*/
    formClick(clickName, data) {
      if (window.$t('common.search') == clickName || '查询' == clickName) {
        this.queryData = data
        this.$refs.childTable.defaultQueryData(data)
      } else if ('回報率' == clickName) {
        data.orderType = 1
      } else if ('勝率' == clickName) {
        data.orderType = 2
      } else if ('跟單人數' == clickName) {
        data.orderType = 3
      }
      this.queryData = data
      this.$refs.childTable.defaultQueryData(data)
    },
    dataChange(url, option, suc, fail) {
      this.$axios.post(url, Qs.stringify(option || {})).then(res => {
        if (suc && (typeof suc == 'function')) suc(res)
      }).catch(res => {
        if (fail && (typeof fail == 'function')) fail(res)
      })
    }

  },
  data() {
    return {
      queryData: {},
      /*from查询表单*/
      formData: {
        hasLable: true,
        cols: [
          { title: '跟单客户账号', field: 'customerNumber', required: true },
          { title: '公司ID', field: 'companyId', required: true },
          { title: '交易平台', field: 'platform', required: true },
          { title: '天數', field: 'days', type: 2, optionList: daysArr, required: true },
          { title: '信號源狀態', field: 'status', type: 2, optionList: statusArr },
          { click: window.$t('common.search') },
          { click: '回報率' },
          { click: '勝率' },
          { click: '跟單人數' }
        ]
      },
      subscribeSettingData: {
        submit: 'hidden',
        hasLable: true,
        cols: [
          { title: '跟单客户账号', field: 'customerNumber', readonly: true },
          { title: '跟单客户所属公司', field: 'companyId', readonly: true, hidden: true },
          { title: '跟单客户所属业务', field: 'businessType', readonly: true },
          { title: '跟单平台', field: 'platform', readonly: true },
          {
            title: '开始跟单时间', field: 'createTime', readonly: true, render: (data, full) => {
              return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
            }
          },
          { title: '跟单手数设置', field: 'volume', readonly: true },
          { title: '跟单总手数上限', field: 'maxTotalLotSize', readonly: true },
          { title: '保证金跟单止损设置', field: 'stopLoss', readonly: true },
          { title: '保证金跟单止盈设置', field: 'stopProfit', readonly: true }
        ]
      },
      subscribeData: {
        hasLable: true,
        cols: [
          { title: '信號源Key', field: 'signalKey', readonly: true },
          { title: '賬號', field: 'customerNumber' },
          { title: '公司ID', field: 'companyId' },
          { title: '交易平台', field: 'platform' },
          { title: '跟单手数设置', field: 'volume' },
          { title: '跟单总手数上限', field: 'maxTotalLotSize' },
          { title: '保证金跟单止损设置', field: 'stopLoss' },
          { title: '保证金跟单止盈设置', field: 'stopProfit' }
        ]
      },
      /*table生成*/
      pageData: {
        isShow: false,
        queryUrl: Url.signal.hall,
        selection: false,
        sequence: true,
        size: 10,
        method: 'get',
        cols: [
          { title: '信號源唯一標識', field: 'signalKey' },
          { title: '信號源賬號', field: 'signalSubscribeNumber' },
          {
            title: '信號源狀態', field: 'status', type: 2, render: (data, full) => {
              return statusArr[data]
            }
          },
          { title: '訂閱情況', field: 'subscribe' },
          { title: 'UI端昵称', field: 'nickName' },
          { title: '目前跟單人數', field: 'nowTrack' },
          { title: '最多允许跟单人数', field: 'maxTrack' },
          { title: '最近收益率', field: 'returnRate' },
          { title: '最近平仓胜率', field: 'winningRate' },
          { title: '最近交易总笔数', field: 'closeTotalNum' },
          { title: '交易最多產品', field: 'moreTradeSymbols' },
          { title: '訂閱的唯一key', field: 'subscribeCustomerKey' },
          { title: '訂閱人的賬戶', field: 'subscribeCustomerNumber' },
          { title: '訂閱人的公司', field: 'subscribeCompanyId' },
          {
            title: '創建時間', field: 'createTime', render: (data, full) => {
              return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
            }
          },
          {
            title: 'updateTime', field: 'updateTime', render: (data, full) => {
              return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
            }
          },
          {
            title: '操作',
            btnClick: [
              {
                name: '訂閱',
                click: 'subscribe',
                auth: 'signal:subscribe:add'
              },
              {
                name: '取消訂閱',
                click: 'unsubscribe',
                auth: 'signal:subscribe:cancel',
                hidden: (model, col) => {
                  return col.subscribe ? false : true
                }
              },
              {
                name: '訂閱配置詳情',
                click: 'subscribeSetting',
                auth: 'signal:subscribe:setting',
                hidden: (model, col) => {
                  return col.subscribe ? false : true
                }
              }
            ]
          }
        ]
      }
    }
  }
}
</script>
